import React from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import {setAuthorCreator} from '../Store/Home/Actions';

interface AuthorLinkProps {
  id: number;
  children?: React.ReactNode;

  setAuthor: (id: number) => Promise<void>;
}

function AuthorLink({id, setAuthor, children}: AuthorLinkProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setAuthor(id);
    window.scrollTo(0, 0);
  };

  return (
    <a href={`/public/author/${id}`} className="post-author" onClick={handleClick}>
      {children}
    </a>
  );
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setAuthor: (id: number) => dispatch(setAuthorCreator(id)),
  };
};

export default connect(null, mapDispatchToProps)(AuthorLink);
